/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createItem = `mutation CreateItem($input: CreateItemInput!) {
  createItem(input: $input) {
    id
    name
    description
    category
    cost
    vendor
    itemNumber
    location
    vendorLink
    nwItemNumber
    swItemNumber
    imageUrl
  }
}
`;
export const updateItem = `mutation UpdateItem($input: UpdateItemInput!) {
  updateItem(input: $input) {
    id
    name
    description
    category
    cost
    vendor
    itemNumber
    location
    vendorLink
    nwItemNumber
    swItemNumber
    imageUrl
  }
}
`;
export const deleteItem = `mutation DeleteItem($input: DeleteItemInput!) {
  deleteItem(input: $input) {
    id
    name
    description
    category
    cost
    vendor
    itemNumber
    location
    vendorLink
    nwItemNumber
    swItemNumber
    imageUrl
  }
}
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations.js